if (!customElements.get("message-toggle")) {
  class MessageToggle extends HTMLElement {
    constructor() {
      super();

      this.handleChangeRef = this.handleChange.bind(this);
      this.handleClickRef = this.handleClick.bind(this);
    }

    dispatchChange() {
      document.dispatchEvent(new CustomEvent("cart:message-toggle"));
    }

    handleClick(event) {
      event.preventDefault();

      this.dispatchChange();
    }

    handleChange() {
      this.dispatchChange();
    }

    disconnectedCallback() {
      this.removeEventListener("change", this.handleChangeRef);
      this.removeEventListener("click", this.handleClickRef);
    }

    connectedCallback() {
      this.addEventListener("change", this.handleChangeRef);
      this.addEventListener("click", this.handleClickRef);
    }
  }

  customElements.define("message-toggle", MessageToggle);
}
